function parseSemver(version) {
	const parts = (version || '').split('.')
	const result = [0, 0, 0]
	for (let i = 0; i < 3 && i < parts.length; i++) {
		const n = parseInt(parts[i], 10)
		if (!Number.isNaN(n)) result[i] = n
	}
	return result
}

function compareSemver(a, b) {
	const aParts = parseSemver(a)
	const bParts = parseSemver(b)
	for (let i = 0; i < 3; i++) {
		if (aParts[i] !== bParts[i]) return aParts[i] - bParts[i]
	}
	return 0
}

function sortVersionsDesc(versions) {
	return [...versions].sort((a, b) => compareSemver(b, a))
}

export { parseSemver, compareSemver, sortVersionsDesc }
